import { render, staticRenderFns } from "./ListingCategory.vue?vue&type=template&id=1b44226e"
import script from "./ListingCategory.vue?vue&type=script&lang=js"
export * from "./ListingCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports